import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import PolygonDIcon from 'components/icons/PolygonD';
import { baseColors } from 'utils/constants';

type Props = {
  question: React.ReactNode;
  answer: React.ReactNode;
};

const FaqAccordion = (props: Props) => {
  const { question, answer } = props;

  return (
    <Accordion square={true} sx={{ boxShadow: 'none', borderTop: `1px solid ${baseColors.lineGray}` }}>
      <AccordionSummary
        expandIcon={<PolygonDIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{ padding: { xs: '0px 10px 0 0', sm: '0px 16px' } }}
      >
        <Typography component="span" sx={{ fontSize: { xs: '14px', sm: '16px' }, paddingRight: { xs: '10px', sm: '16px' } }}>
          {question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{ margin: { xs: '10px 0', sm: '10px' }, backgroundColor: baseColors.gray, fontSize: { xs: '14px', sm: '16px' } }}
      >
        {answer}
      </AccordionDetails>
    </Accordion>
  );
};
export default FaqAccordion;
